import React from 'react';
import styles from './ModalInfotext.module.css';

interface ModulInfoTextProps {
  meddelande: string;
  style?: object;
}

const ModalInfotext = (props: ModulInfoTextProps) => {
  return (
    <>
      <div className={styles.hjalpruta} style={props.style}>
        {props.meddelande}
      </div>
    </>
  );
};

export default ModalInfotext;
